<script>
import Cookies from "js-cookie";
import {notificationMethods, campaignsMethods, courseMethods} from "@/state/helpers";
import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import api from "@/helpers/axios";
import Multiselect from 'vue-multiselect'

export default {
  page: {
    title: "Campaigns",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
    Multiselect
  },
  data() {
    return {
      types: [
        {value: 'coupon', label: 'Kupon'},
        {value: 'cart', label: 'Sepet'}
      ],
      siteSelected:false,
      contents: [
        {value: 'courses', label: 'Seçili Kurslar'},
        {value: 'all', label: 'Tüm Kurslar'}
      ],
      courses: [],
      campaign:null,
      sites: [],
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      currentUser: JSON.parse(Cookies.get('user')),
      campaigns: [],
      title: "Kampanyalar ve İndİrİmler Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kampanyalar ve İndirimler",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      addForm: {
        site: null,
        name: "",
        description: null,
        image: null,
        content: null,
        type: "coupon",
        code:null,
        courses: [],
        show: true,
        status: true,
        discount: 0
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label:'Kampanya Adı',
          sortable: true,
        },
        {
          key: "site",
          label:'Site',
          sortable: true,
        },
        {
          key: "status",
          label:'Durum',
          sortable: true,
        },

        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },
  validations: {
    addForm: {
      site: {required},
      name: {required},
      content: {required},
      type: {required},
      //code: {required},
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return this.totalRows ? Math.ceil(this.totalRows / this.perPage) : 0;
    },
  },
  watch: {
    'showModal': function (item) {
      if(item) {
        this.campaign = null
      }
    },
    page(newPage) {
      this.pageInput = newPage;
      this.getCampaigns(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getCampaigns();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.turkishToLower(this.addForm.email)
    }
  },
  mounted() {
    this.getCampaigns();
    this.fetchSites();
    // Site seçimi izleme
    this.$watch('siteSelected', (newValue) => {
      if (newValue) {
        this.addForm.showInCampaigns = false;
      } else {
        this.addForm.showInCampaigns = false;
      }
    });
  },
  methods: {
    ...campaignsMethods,
    ...notificationMethods,
    ...courseMethods,
    async fetchSites() {
      try {
        const response = await api.get("/sites");
        this.sites = response.data.data.docs;
      } catch (error) {
        return
      }
    },
    getCourses() {
      if(this.addForm.content === 'courses') {
        this.fetchCourses({
          site: this.addForm.site,
          page: this.page,
          limit: 9999
        }).then((res) => {
          this.courses = res.docs

        });
      }
    },
    resetForm() {
      this.addForm = {
        site: null, //required
        name: "",  //required
        description: null,
        image: null,
        content: null,  //required
        type: "coupon",  //required
        code:null,
        courses: [],
        show: true,
        status: true
      };
      this.addSubmitted = false;
      this.editSubmitted = false;
    },
    handleImageUpload(event, form) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        form.image = selectedFile;
      }
    },
    doSearch() {
      if (this.page === 1) {
        this.getCampaigns();
      } else {
        this.page = 1;
      }
    },
    getCampaigns(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchCampaigns({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        this.items = res.docs
        this.itemsLoaded = true;
      })
    },
    async getCampaign(campaign) {
      const form = Object.keys(this.addForm);
      await this.fetchCampaign({campaign}).then(res => {
        this.campaign = campaign;
        for (let edit of Object.keys(res)) {
          if (form.includes(edit)) {
            this.addForm[edit] = res[edit];
          }
        }
        this.getCourses();
      })
    },
    handleSubmit() {
      this.addSubmitted = true;
      this.formError = "";
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {

        if(this.campaign) {
          this.updateCampaign({id:this.campaign,
            data: this.addForm
          }).then(() => {
            this.toastMessage = "Kampanya başarıyla güncellendi!";
            this.toastAction = "success";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
            this.showModal = false;
            this.getCampaigns();

          }).catch(() => {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          })
        } else {
          this.createCampaign({
            ...this.addForm
          }).then(() => {
            this.toastMessage = "Kampanya başarıyla eklendi!";
            this.toastAction = "success";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
            this.showModal = false;
            this.getCampaigns();

          }).catch(() => {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          })
        }

      }
    },
    handleDeleteSubmit() {
      this.deleteCampaign(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Kampanya başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getCampaigns();
      })
    },
    openEdit(campaign) {
      this.showModal = true;
      this.getCampaign(campaign);
    },
    openDelete(campaign) {
      if (campaign.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = campaign.id;
        this.deleteModal = true;
      }
    },
    turkishToLower(str) {
      let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) {
        return letters[letter];
      })
      return str.toLowerCase();
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm()"
                >
                  Kampanya Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(site)="data">
                    {{ data.item.site.domain }}
                  </template>


                  <template v-slot:cell(status)="data">
                    <td v-if="data.item.status" class="align-middle">
                      <span class="badge badge-pill badge-soft-success font-size-14">Aktif</span>
                    </td>
                    <td v-else class="align-middle">
                      <span class="badge badge-pill badge-soft-danger font-size-14">Pasif</span>
                    </td>
                  </template>

                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'campaignDetail',params:{campaignId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item._id)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"
                           class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showModal" title="Kampanya" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="field" class="me-2">Aktif</label>
                <input
                    id="field"
                    type="checkbox"
                    v-model="addForm.status"
                    class="form-check-input"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3  ">
                <label for="site">Site Seçiniz</label>
                <select id="site" v-model="addForm.site" class="form-control" :class="{
    'is-invalid': addSubmitted && $v.addForm.site.$error,
  }">
                  <option value="">Site Seçiniz</option>
                  <option v-for="site in sites" :key="site.id" :value="site.id">{{ site.name }}</option>
                </select>
                <div
                    v-if="addSubmitted && !$v.addForm.site.required"
                    class="invalid-feedback"
                >
                  Site seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3  ">
                <label class="me-2">Kampanya Tipi</label>
                <div class="checkbox-group ">
                  <label :for="'types'+type.value"  v-for="type in types" :key="type.value" class="me-2">
                    <input
                        :id="'types'+type.value"
                        type="radio"
                        :value="type.value"
                        v-model="addForm.type"
                        class="form-check-input  "
                    />
                    {{ type.label  }}
                  </label>
                </div>
                <div
                    v-if="addSubmitted && !$v.addForm.type.required"
                    class="invalid-feedback"
                >
                  Kampanya tipi seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3  ">
                <label for="contentType">Etki Tipi</label>
                <select @change="this.getCourses" id="contentType" v-model="addForm.content" class="form-control" :class="{
    'is-invalid': addSubmitted && $v.addForm.content.$error,
  }">
                  <option value="">Seçiniz</option>
                  <option v-for="content in contents" :key="content.id" :value="content.value">{{ content.label }}</option>
                </select>
                <div
                    v-if="addSubmitted && !$v.addForm.content.required"
                    class="invalid-feedback"
                >
                  Etki tipi seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="addShowInCampaigns">Sitede Kampanyalarda Göster</label>
                <div class="checkbox-group ">
                  <label for="addShowInCampaigns" class="me-2">
                    <input
                        type="radio"
                        id="addShowInCampaigns"
                        value="true"
                        v-model="addForm.show"
                        class="form-check-input  "
                    />
                    Evet
                  </label>
                  <label for="addHideInCampaigns" class="me-2">
                    <input
                        type="radio"
                        id="addHideInCampaigns"
                        value="false"
                        v-model="addForm.show"
                        class="form-check-input  "
                    />
                    Hayır
                  </label>

                </div>
              </div>
            </div>
            <div v-if="addForm.content === 'courses'" class="col-12">
              <div class="mb-3">
                <label for="courses">Kurslar</label>
                <multiselect
                    id="courses"
                    label="name"
                    v-model="addForm.courses"
                    :options="courses"
                    placeholder="Rolleri seçin"
                    multiple
                    :select-label="'Seçiniz'"
                    :selected-label="'Kaldır'"
                    :selected-text="'Kaldır'"
                ></multiselect>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Kampanya Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Kampanya adı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Kampanya Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="addImage">Kampanya Görseli</label>
                <input
                    id="addImage"
                    type="file"
                    @change="handleImageUpload($event, addForm)"
                    accept="image/*"
                    class="form-control "
                />
              </div>
            </div>
            <div v-if="addForm.type === 'coupon'" class="col-6">
              <div class="mb-3">
                <label for="code">Kampanya Kodu</label>
                <input
                    id="code"
                    type="text"
                    v-model="addForm.code"
                    class="form-control"
                    placeholder="Kampanya kodu giriniz"
                />
              </div>
            </div>
            <div  class="col-6">
              <div class="mb-3">
                <label for="discount">İndirim Oranı (%)</label>
                <input
                    id="discount"
                    type="text"
                    v-model="addForm.discount"
                    class="form-control"
                    placeholder="İndirim oranı giriniz"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description">Kampanya Açıklaması</label>
                <textarea
                    id="description"
                    type="text"
                    v-model="addForm.description"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                ></textarea>

              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm()"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >{{ !this.campaign ? 'Kampanya Ekle' : 'Kampanya Düzenle' }}
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu Kampanyaı silmek istediğinize emin misiniz? Silinmiş Kampanyaı geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız Siteyi silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
